export default "__VITE_ASSET__e0dbaa3c__"